import { __assign } from 'tslib';
import React from 'react';
import clsx from 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';
import BrowseButton from '../components/BrowseButton/BrowseButton.js';
import '../../buttons/index.js';
import './../../../assets/src/components/file-uploadV2/components/ProcessingZone/ProcessingZone.css.ts.vanilla-36b1cf63.css';
import { cssCloudImage } from '../index.css.js';
import activeCloudImage from './active-cloud-computing.png.js';

var UploadDropzoneComponent = function (_a) {
    var type = _a.type, fileBrowseTitle = _a.fileBrowseTitle, dragDropTitle = _a.dragDropTitle, dropzoneClass = _a.dropzoneClass, _b = _a.classes, classes = _b === void 0 ? {} : _b, disabled = _a.disabled, getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, open = _a.open;
    var isCondensed = type === 'condensed';
    var isLarge = type === 'large';
    var isSimple = type === 'simple';
    return (React.createElement("div", __assign({}, getRootProps(), { className: !isSimple ? clsx(dropzoneClass, classes.dropzone) : classes.dropzone }),
        React.createElement(Visible, { when: isLarge },
            React.createElement("img", { className: clsx('c-cloud-image', classes.image, cssCloudImage), src: activeCloudImage })),
        React.createElement("input", __assign({ "data-testid": 'upload-file-input' }, getInputProps())),
        React.createElement(Visible, { when: !isSimple },
            React.createElement("div", { "data-testid": 'dropzone-title', className: clsx('c-dropzone__title', isCondensed && 'c-dropzone__title--condensed', classes.title) }, dragDropTitle)),
        React.createElement(BrowseButton, { title: fileBrowseTitle, onClick: open, classes: classes, disabled: disabled, isDropzoneCondensed: isCondensed })));
};

export { UploadDropzoneComponent as default };
//# sourceMappingURL=UploadDropzoneComponent.js.map
